import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import {
  FETCH_DEFAULT_SCORING_CONFIG,
  fetchDefaultScoringConfigSuccess,
  fetchDefaultScoringConfigFail,
  SAVE_DEFAULT_SCORING_CONFIG,
  saveDefaultScoringConfigSuccess,
  saveDefaultScoringConfigFail
} from '../../redux/actions/trm/defaultScoringConfig';
import * as api from '../../services/trm/trmServices';

const networkLayerObject = new api.NetworkLayer();

// `payload` is optional ({ alertId } from the Spatial alert view, FIN-13569).
function* fetchDefaultScoringConfigWorker({ payload } = {}) {
  try {
    const data = yield call(
      networkLayerObject.getDefaultScoringConfigAPI,
      payload
    );
    yield put(fetchDefaultScoringConfigSuccess(data));
  } catch (error) {
    yield put(fetchDefaultScoringConfigFail(error?.message || String(error)));
  }
}

function* saveDefaultScoringConfigWorker({ payload }) {
  try {
    yield call(networkLayerObject.putDefaultScoringConfigAPI, payload);
    yield put(saveDefaultScoringConfigSuccess(payload.config));
    message.success('Default scoring configuration saved.');
  } catch (error) {
    const msg = error?.message || 'Failed to save default scoring config';
    yield put(saveDefaultScoringConfigFail(msg));
    message.error(msg);
  }
}

export function* watchFetchDefaultScoringConfig() {
  yield takeLatest(
    FETCH_DEFAULT_SCORING_CONFIG,
    fetchDefaultScoringConfigWorker
  );
}
export function* watchSaveDefaultScoringConfig() {
  yield takeLatest(SAVE_DEFAULT_SCORING_CONFIG, saveDefaultScoringConfigWorker);
}
